import { Chip } from "@mui/material";

// A pricing model as an outlined chip in its own colour. Model colours are an
// official identity scale, always shown raw and only as a swatch (border +
// tint): light colours such as LOW L are unreadable as text on the light scheme.
const ModelChip = ({
  label,
  color,
}: {
  label: string;
  color?: string | null;
}) => (
  <Chip
    size="small"
    variant="outlined"
    label={label}
    sx={{
      fontWeight: 700,
      fontSize: "0.6875rem",
      borderRadius: 1,
      ...(color
        ? {
            color: "text.primary",
            borderColor: color,
            backgroundColor: `color-mix(in srgb, ${color} 12%, transparent)`,
          }
        : {}),
    }}
  />
);

export default ModelChip;
